module.exports = __webpack_public_path__ + "static/img/Bachelor_010705.5d25231.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010705.jpg
// module id = 227
// module chunks = 0